import { render, staticRenderFns } from "./order-view-receiver.vue?vue&type=template&id=03b1d512&"
import script from "./order-view-receiver.vue?vue&type=script&lang=js&"
export * from "./order-view-receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports